import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/styles/globals.css';

async function bootstrap() {
  // DEV-ONLY: when VITE_PREVIEW=1, install the mock adapter so the portal runs
  // with sample data and no backend. Dynamically imported so it is tree-shaken
  // out of production builds.
  if (import.meta.env.DEV && import.meta.env.VITE_PREVIEW === '1') {
    const { installPreviewMock } = await import('@/dev/previewMock');
    installPreviewMock();
  }
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void bootstrap();
